export default __webpack_public_path__ + "static/media/i_alert_location.1aa36e08.svg";